<template lang="pug">
div.report-taxes-settings(:class="{ 'report-taxes-dark': isDark }")
  div.report-taxes-header
    div.report-taxes-title
      v-avatar.report-taxes-icon(size="48")
        v-icon(size="26") mdi-percent-outline
      div
        h2.fonte Impostos do relatorio
        span.fonteMini Cadastre deducoes aplicadas sobre o faturamento bruto ou liquido.
    v-btn(class="fonte white--text elevation-0" rounded :color="$theme.third" @click="addTax")
      v-icon(left size="18") mdi-plus
      | Novo imposto

  div.report-taxes-empty(v-if="normalizedTaxes.length === 0")
    v-icon(size="42") mdi-receipt-text-plus-outline
    strong.fonte Nenhum imposto cadastrado
    span.fonteMini Adicione impostos para que aparecam como deducao no relatorio de vendas.

  div.report-taxes-list(v-else)
    div.report-tax-row(v-for="(tax, index) in normalizedTaxes" :key="tax.id || index")
      v-text-field(filled dense hide-details label="Nome" placeholder="Ex: Simples Nacional" v-model="tax.nome" @change="save")
      v-text-field.report-tax-percent(filled dense hide-details suffix="%" type="number" label="Percentual" placeholder="Ex: 5" v-model="tax.percentual" @change="save")
      v-select.report-tax-base(filled dense hide-details label="Base" :items="baseOptions" item-text="text" item-value="value" v-model="tax.base" @change="save")
      v-switch.report-tax-active(dense hide-details inset :color="$theme.third" v-model="tax.ativa" @change="save")
      v-btn(icon @click="removeTax(index)")
        v-icon(color="red lighten-1") mdi-delete-outline
</template>

<script>
import { EventBus } from "@/main";

export default {
  props: ["report_taxes"],
  data() {
    return {
      baseOptions: [
        { text: "Faturamento bruto", value: "gross" },
        { text: "Liquido apos taxas", value: "net" }
      ]
    };
  },
  computed: {
    isDark() {
      return localStorage.dark === "true";
    },
    normalizedTaxes() {
      return Array.isArray(this.report_taxes) ? this.report_taxes : [];
    }
  },
  methods: {
    addTax() {
      this.normalizedTaxes.push({
        id: `report_tax_${Date.now()}`,
        nome: "",
        percentual: 0,
        base: "gross",
        ativa: true
      });
    },
    removeTax(index) {
      this.normalizedTaxes.splice(index, 1);
      this.save();
    },
    save() {
      const invalidTax = this.normalizedTaxes.find(tax => !tax.nome);
      if (invalidTax) return;
      EventBus.$emit("saveReportTaxes", this.normalizedTaxes);
    }
  }
};
</script>

<style scoped>
.report-taxes-settings {
  color: #1f2a2e;
  padding: 4px 0 24px;
}
.report-taxes-header {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(18, 140, 126, 0.12);
  border-radius: 8px;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  margin-bottom: 14px;
  padding: 18px;
}
.report-taxes-title {
  align-items: center;
  display: flex;
  gap: 14px;
}
.report-taxes-title h2 {
  margin: 0;
}
.report-taxes-title span,
.report-taxes-empty span {
  color: #607178;
}
.report-taxes-icon {
  background: #25D366;
  color: #0b141a;
}
.report-taxes-icon .v-icon {
  color: #0b141a !important;
}
.report-taxes-empty {
  align-items: center;
  background: #ffffff;
  border: 1px dashed rgba(18, 140, 126, 0.26);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 180px;
  justify-content: center;
  text-align: center;
}
.report-taxes-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.report-tax-row {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(18, 140, 126, 0.12);
  border-radius: 8px;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(180px, 1fr) 150px 210px 72px 42px;
  padding: 12px;
}
.report-tax-active {
  margin-top: 0;
}
.report-taxes-dark {
  color: #e9edef;
}
.report-taxes-dark .report-taxes-header,
.report-taxes-dark .report-taxes-empty,
.report-taxes-dark .report-tax-row {
  background: #111b21;
  border-color: #26343c;
  color: #e9edef;
}
.report-taxes-dark span,
.report-taxes-dark ::v-deep .v-label,
.report-taxes-dark ::v-deep .v-select__selection {
  color: #aebac1 !important;
}
.report-taxes-dark ::v-deep .v-input__slot,
.report-taxes-dark ::v-deep input {
  background: #202c33 !important;
  color: #e9edef !important;
}
@media(max-width: 900px) {
  .report-taxes-header {
    align-items: stretch;
    flex-direction: column;
  }
  .report-tax-row {
    grid-template-columns: 1fr;
  }
}
</style>
